import { AdditionalMedicineInformation } from '@dreryk/drerykweb-medicine-api';

import { Translate } from '@dreryk/react-common';

import { ORDERED_ADDITIONAL_INFORMATION_ACCORDION_SECTIONS } from '~libs.shared.medicine';

import { translationKeys } from '../../../../translations';

import { getMedicineDetailsAdditionalInformationContentText } from './MedicineDetailsAdditionalInformationContent.utils';
import {
   StyledMedicineDetailsAdditionalInformationContent,
   StyledMedicineDetailsAdditionalInformationItem,
} from './MedicineDetailsAdditionalInformationContent.styled';

type MedicineDetailsAdditionalInformationContentProps = {
   readonly additionalInformation?: AdditionalMedicineInformation;
};

const MedicineDetailsAdditionalInformationContent = (
   props: MedicineDetailsAdditionalInformationContentProps
): JSX.Element => {
   return (
      <StyledMedicineDetailsAdditionalInformationContent>
         {ORDERED_ADDITIONAL_INFORMATION_ACCORDION_SECTIONS.map((key) => {
            return (
               <StyledMedicineDetailsAdditionalInformationItem key={key}>
                  <div>
                     <Translate>{translationKeys.medicine.details.additionalInformationAccordion[key]}</Translate>
                     {':'}
                  </div>

                  <div>{getMedicineDetailsAdditionalInformationContentText(key, props.additionalInformation!)}</div>
               </StyledMedicineDetailsAdditionalInformationItem>
            );
         })}
      </StyledMedicineDetailsAdditionalInformationContent>
   );
};

export { MedicineDetailsAdditionalInformationContent };
